import styled, {createGlobalStyle} from "styled-components";
export const GlobalStyle = createGlobalStyle`
	#light {
		color: var(--txt-dg);
		#body p {
			color: var(--txt-dg);
		}
		.search-field {
			background: #fff;
			color: var(--txt-dg);
		}
		.dashboard-row {
			background: #fff !important;
			.favicon {
				border: 1px solid var(--bg-l1);
				background: var(--bg-l1);
			}
			.siteid span {
				color: var(--txt-dg);
			}
		}
		.companies .company {
			background: #fff !important;
			border-color: hsl(240 5.9% 90%) !important;
			&:hover {
				border-color: var(--blue) !important;
				background: var(--bg-l1) !important;
			}
		}
		.filters .search-field,
		.filters .sort-by {
			background-color: var(--bg-l1) !important;
			color: var(--txt-dg) !important;
			border-color: hsl(240 5.9% 90%) !important;
		}
		.filters .sort-by option {
			background-color: #fff;
			color: var(--txt-dg);
		}
		.companies .company .admin-id {
			background-color: var(--bg-l1);
			border-color: hsl(240 5.9% 90%);
			color: var(--txt-dg);
		}
		.input-group {
			.form-input {
				/* background-color: rgba(0, 0, 0, 0.05); */
			}
		}
		.search-wrapper .search-header h1 {
			color: #000;
		}
		.search-wrapper {
			.card {
				background: #fff !important;
				border-color: hsl(240 5.9% 90%) !important;
			}
			.card-header h2 {
				color: var(--txt-dg);
			}
			.form-label {
				color: var(--txt-dg);
			}
			input.form-input,
			select.form-input,
			.react-date-picker.form-input,
			.search-header select {
				background-color: #fff !important;
				color: var(--txt-dg) !important;
				border-color: hsl(240 5.9% 90%) !important;
			}
			.react-date-picker__inputGroup__input {
				color: var(--txt-dg);
			}
			.rsel__control,
			.rsel__menu {
				background-color: #fff !important;
				border-color: hsl(240 5.9% 90%) !important;
			}
			.rsel__single-value,
			.rsel__input,
			.rsel__option {
				color: var(--txt-dg) !important;
			}
			.rsel__option--is-selected {
				color: #fff !important;
			}
			.rsel__multi-value {
				background-color: var(--bg-l1) !important;
			}
			.rsel__multi-value__label {
				color: var(--txt-dg) !important;
			}
		}
		.leaderboard-wrapper {
			border-color: hsl(240 5.9% 90%);
			background: rgba(255, 255, 255, 0.02);
		}
		.leaderboard-header,
		.leaderboard-table th,
		.leaderboard-table td {
			border-color: hsl(240 5.9% 90%);
		}
		.leaderboard-title,
		.leaderboard-controls label,
		.leaderboard-table th,
		.leaderboard-table td {
			color: var(--txt-dg);
		}
		.leaderboard-subtitle,
		.leaderboard-state,
		.leaderboard-table .rank {
			color: var(--txt-lg);
		}
		.leaderboard-controls .date-field,
		.leaderboard-controls .apply-btn {
			background-color: var(--bg-l1);
			border-color: hsl(240 5.9% 90%);
			color: var(--txt-dg);
			color-scheme: light;
		}
		.leaderboard-controls .apply-btn:hover {
			background-color: var(--bg-l2);
		}
		.leaderboard-table th:first-child,
		.leaderboard-table td:first-child {
			background: var(--bg-l1);
		}
		.leaderboard-table .rank {
			background: var(--bg-l2);
		}
	}
`;

export const DashboardWrapperEl = styled.div`
	.dash-body-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: calc(100vh - 60px);
		margin-top: 0 !important;
		padding: 2em 4em 4em 19em !important;
		overflow-y: auto;
		gap: 20px;
		&.show {
			animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-webkit-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-moz-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-o-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
		}
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
			font-size: 28px;
			/* color: var(--txt-dg); */
			font-weight: 600;
		}

		.add-btn {
			display: flex;
			align-items: center;
			gap: 5px;
			font-size: 14px;
			font-weight: 700;
			letter-spacing: 0.3px;
			color: #fff;
			background-color: var(--pink);
			border: 2px solid var(--pink);
			border-radius: 2em;
			padding: 0.7em 1.75em;
			cursor: pointer;
			box-shadow: 0 4px 14px rgba(255, 0, 140, 0.3);
			transition: transform 0.08s ease, box-shadow 0.12s ease, background-color 0.12s ease;

			&:hover {
				background-color: #ff2da0;
				border-color: #ff2da0;
				box-shadow: 0 6px 20px rgba(255, 0, 140, 0.45);
				transform: translateY(-1px);
			}

			&:active {
				transform: translateY(0);
			}
		}
	}

	.filters {
		display: flex;
		align-items: center;
		gap: 10px;

		.search-field {
			width: 100%;
			max-width: 400px;
			height: 40px;
			border-radius: 6px;
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
			padding: 0 12px;
			font-size: 14px;
			color: var(--txt-l);
			background-color: var(--bg-d0-dash);
			outline: none;
			transition: border-color 0.15s ease;

			&:focus {
				border-color: var(--blue);

				&::placeholder {
					color: var(--txt-lg);
				}
			}

			&::placeholder {
				color: var(--txt-lg);
			}
		}

		.sort-by {
			height: 40px;
			border-radius: 6px;
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
			padding: 0 10px;
			font-size: 14px;
			color: var(--txt-l) !important;
			background-color: var(--bg-d0-dash);
			outline: none;
			transition: border-color 0.15s ease;
			cursor: pointer;

			&:focus {
				border-color: var(--blue) !important;
			}
			& option {
				color: var(--txt-l);
				background-color: var(--bg-d0-dash);
			}
		}
			

		.right {
			margin-left: auto;
			
			.count {
				font-size: 14px;
				color: var(--txt-lg);
				font-weight: 300;
			}
		}
	}

	.leaderboard-wrapper {
		flex: 0 0 auto;
		border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		border-radius: 10px;
		background: var(--bg-d2);
		overflow: hidden;
	}

	.leaderboard-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		padding: 16px 18px;
		border-bottom: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
	}

	.leaderboard-title-wrapper {
		display: flex;
		align-items: baseline;
		gap: 10px;
		min-width: 0;
	}

	.leaderboard-title {
		font-size: 16px;
		font-weight: 700;
		color: var(--txt-l);
	}

	.leaderboard-subtitle {
		font-size: 12px;
		font-weight: 400;
		color: var(--txt-lg);
		white-space: nowrap;
	}

	.leaderboard-controls {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
		justify-content: flex-end;
	}

	.leaderboard-controls label {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		font-weight: 500;
		color: var(--txt-lg);
	}

	.leaderboard-controls .date-field {
		height: 34px;
		border-radius: 6px;
		border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		padding: 0 8px;
		font-size: 12px;
		color: var(--txt-l);
		background-color: var(--bg-d0-dash);
		outline: none;
		color-scheme: dark;
		transition: border-color 0.15s ease;
	}

	.leaderboard-controls .date-field:focus {
		border-color: var(--blue);
	}

	.leaderboard-controls .apply-btn {
		height: 34px;
		border-radius: 6px;
		border: 1px solid var(--blue);
		padding: 0 16px;
		font-size: 12px;
		font-weight: 600;
		color: var(--blue);
		background-color: transparent;
		cursor: pointer;
		transition: background-color 0.15s ease, color 0.15s ease;
	}

	.leaderboard-controls .apply-btn:hover {
		background-color: var(--blue);
		color: #fff;
	}

	.leaderboard-table-wrapper {
		width: 100%;
		overflow-x: auto;
	}

	.leaderboard-state {
		padding: 18px 16px;
		font-size: 13px;
		font-weight: 500;
		color: var(--txt-lg);
	}

	.leaderboard-state.error {
		color: var(--red);
	}

	.leaderboard-table {
		width: 100%;
		min-width: 940px;
		border-collapse: collapse;
		font-size: 12px;
	}

	.leaderboard-table th,
	.leaderboard-table td {
		padding: 10px 12px;
		text-align: right;
		border-bottom: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		color: var(--txt-l);
		white-space: nowrap;
	}

	.leaderboard-table th {
		font-size: 11px;
		font-weight: 700;
		color: var(--txt-lg);
		text-transform: uppercase;
	}

	.leaderboard-table th:first-child,
	.leaderboard-table td:first-child {
		text-align: left;
		position: sticky;
		left: 0;
		background: var(--bg-d2);
	}

	.leaderboard-table tbody tr:last-child td {
		border-bottom: none;
	}

	.leaderboard-table .rank {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 22px;
		height: 22px;
		margin-right: 8px;
		border-radius: 50%;
		background: var(--bg-d0-dash);
		color: var(--txt-lg);
		font-size: 11px;
	}

	.leaderboard-table .person {
		font-weight: 700;
	}

	.leaderboard-table .total {
		font-weight: 800;
	}

	.items {
		flex: 1 1 auto;
		min-height: 0;
		height: auto;
		overflow-y: auto;
		/* border: 1px solid hsl(240 5.9% 90%); */
		border-radius: 5px;

		.loading-wrapper {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			
			.lds-ellipsis {
				top: 50%;
				left: 50%;
				position: absolute;
				transform: translate(-50%, -50%);
			}
		}

		.companies {
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 12px;
			align-content: start;

			.load-more {
				grid-column: 1 / -1;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 16px;

				button {
					background-color: var(--bg-l1);
					border: 1px solid hsl(240 5.9% 90%);
					border-radius: 5px;
					padding: 8px 16px;
					font-size: 14px;
					color: var(--txt-dg);
					cursor: pointer;
					transition: background-color 0.2s ease;

					&:hover {
						background-color: var(--bg-l2);
						border-color: var(--bg-l2);
					}
				}
			}
			
			.company {
				display: flex;
				gap: 12px;
				padding: 18px;
				align-items: center;
				font-size: 12px;
				/* color: var(--txt-lg); */
				font-weight: 400;
				user-select: none;
				cursor: pointer;
				transition: background-color 0.15s ease, border-color 0.15s ease;
				background-color: var(--bg-d2);
				border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
				border-radius: 10px;

				&:hover {
					border-color: var(--blue);
					background-color: var(--bg-dg);
				}

				.info {
					display: flex;
					flex-direction: column;
				}

				.name-wrapper, .subtitle-wrapper {
					display: flex;
					align-items: center;
					gap: 8px;

					.name {
						font-size: 16px;
						font-weight: 600;
						/* color: var(--txt-dg); */
					}

					.subtitle {
						font-size: 14px;
						font-weight: 400;
						color: var(--txt-dg);
					}

					.admin-id {
						border-radius: 50vh;
						border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
						background-color: var(--bg-dg);
						color: var(--txt-lg);
						padding: 2px 8px;
						font-size: 10px;
						font-weight: 600;
						display: flex;
						align-items: center;
						justify-content: center;

						span {
							text-align: center;
						}
					}

					.salesforce-icon {
						display: inline-block;
						height: 4px;
						width: 4px;
						border-radius: 2px;
						background: var(--salesforce-blue);
						padding: 0;
						border: none;
					}
				}

				.favicon-wrapper {
				    height: 45px;
					width: 45px;
					border-radius: 12px;
					flex-shrink: 0;

					.favicon-fallback {
						width: 100%;
						height: 100%;
						border-radius: 50%;
						background: #6b7280;
					}

					img {
						width: 100%;
						height: 100%;
						border-radius: 12px;
						object-fit: cover;
					}

					.form-type {
						text-transform: uppercase;
						font-size: 10px;
						border-radius: 12px;
						font-weight: 900;
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						&.tt {
							background: var(--darkgreen);
						}
						&.lc {
							background: var(--violet);
						}
						&.pc {
							background: var(--blue);
						}
						&.em {
							background: var(--blue);
						}
						&.nc {
							background: var(--gray);
						}
					}
				}	

				.right {
					margin-left: auto;

					.campaign-count {
						font-size: 12px;
						color: var(--txt-lg);
					}
				}
			}
		}
	}

	.footer {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/* Clear the fixed sidebar so the left card isn't hidden underneath it */
	.body-wrapper.search-wrapper {
		left: 0;
		right: 0;
		width: 100%;
		box-sizing: border-box;
		padding: 36px 4em 120px 19em !important;
	}

	.search-wrapper {
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		gap: 8px 0;

		.search-header {
			h1 {
				color: var(--txt-l);
				font-family: "freight-display-pro", "Georgia", serif;
				font-size: 28px;
			}
			width: 100%;
			padding: 0 1rem;
			margin-bottom: 8px;
			select {
				background-color: var(--bg-d0-dash);
				color: var(--txt-l);
				border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
				border-radius: 6px !important;
			}
		}

		/* ---- Cards ---- */
		.card {
			width: 100%;
			margin-bottom: 1rem;
			padding: 1.5em;
			background: var(--bg-d2);
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
			border-radius: 12px;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
			.card-header {
				padding-bottom: 1em;
				h2 {
					font-size: 16px;
					font-weight: 700;
					color: var(--txt-l);
					margin: 0;
				}
			}
		}

		/* ---- Labels & rows ---- */
		.form-label {
			min-width: 10em;
			text-align: right;
			padding-right: 1em;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--txt-lg);
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}

		.input-group {
			display: flex;
			align-items: center;
			padding-bottom: 0.75em;
			.form-input {
				width: 100%;
			}
			.select-group {
				margin-right: 0.75em;
			}
			select.form-input {
				min-width: 9em;
			}
		}

		/* ---- Native inputs / selects ---- */
		input.form-input,
		select.form-input {
			background-color: var(--bg-d0-dash);
			color: var(--txt-l);
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
			border-radius: 6px !important;
			height: 38px;
			padding: 0 10px;
			outline: none;
			transition: border-color 0.15s ease;
			&:focus {
				border-color: var(--blue) !important;
			}
		}
		select.form-input option {
			background-color: var(--bg-d0-dash);
			color: var(--txt-l);
		}

		/* ---- Date pickers ---- */
		.react-date-picker.form-input {
			background-color: var(--bg-d0-dash);
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
			border-radius: 6px !important;
			height: 38px;
			padding: 0 8px;
			color: var(--txt-l);
		}
		.react-date-picker__wrapper {
			border: none !important;
		}
		.react-date-picker__inputGroup__input {
			color: var(--txt-l);
		}
		.react-date-picker__inputGroup__divider,
		.react-date-picker__inputGroup__leadingZero {
			color: var(--txt-lg);
		}
		.react-date-picker__clear-button svg {
			stroke: var(--txt-lg);
		}
		.react-date-picker__clear-button:hover svg {
			stroke: var(--red);
		}

		/* ---- react-select (classNamePrefix="rsel") ---- */
		.rsel__control {
			background-color: var(--bg-d0-dash) !important;
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
			border-radius: 6px !important;
			box-shadow: none !important;
			min-height: 38px;
		}
		.rsel__control--is-focused {
			border-color: var(--blue) !important;
		}
		.rsel__placeholder {
			color: var(--txt-lg) !important;
		}
		.rsel__input-container,
		.rsel__input,
		.rsel__single-value {
			color: var(--txt-l) !important;
		}
		.rsel__multi-value {
			background-color: var(--bg-dg) !important;
			border-radius: 4px;
		}
		.rsel__multi-value__label {
			color: var(--txt-l) !important;
		}
		.rsel__multi-value__remove {
			color: var(--txt-lg) !important;
			&:hover {
				background-color: var(--red) !important;
				color: #fff !important;
			}
		}
		.rsel__indicator-separator {
			background-color: var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
		}
		.rsel__dropdown-indicator,
		.rsel__clear-indicator {
			color: var(--txt-lg) !important;
		}
		.rsel__menu {
			background-color: var(--bg-d0-dash) !important;
			border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16)) !important;
			z-index: 5;
		}
		.rsel__option {
			background-color: transparent !important;
			color: var(--txt-l) !important;
		}
		.rsel__option--is-focused {
			background-color: var(--bg-dg) !important;
		}
		.rsel__option--is-selected {
			background-color: var(--blue) !important;
			color: #fff !important;
		}

		/* ---- Checkboxes ---- */
		.checkbox-group {
			margin: 0.5em 0;
			line-height: 1;
			display: flex;
			align-items: center;
			input {
				margin-right: 0.5em;
				accent-color: var(--blue);
			}
		}

		/* ---- Results ---- */
		.search-results {
			width: 100%;
			.salesforce-record {
				border-bottom: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
				padding-bottom: 1em;
				margin-bottom: 1em;
				display: flex;
				& > div {
					flex: 1 1;
				}
			}
			.search-header {
				display: flex;
				label {
					margin-left: auto;
				}
			}
		}
	}
	@keyframes dashboard-body-show-ani {
		0% {
			opacity: 0;
			top: 70px;
		}
		100% {
			opacity: 1;
			top: 60px;
		}
	}

	.badge {
		color: #fff !important;
		text-transform: uppercase;
		font-weight: 900;
		&.tt {
			background: var(--darkgreen) !important;
		}
		&.lc {
			background: var(--violet) !important;
		}
		&.pc,
		&.em {
			background: var(--blue) !important;
		}
		&.nc {
			background: var(--gray) !important;
		}
	}
	& .dashboard-column {
		display: inline-block;
		vertical-align: top;
		min-height: 100px;
		position: relative;
		width: 25%;
		padding: 0 5px 15px 5px;
		max-width: 400px;
	}
	.search-all-wrapper .favicon-wrapper {
		margin: 0 10px 15px !important;
		float: left;
	}
	& .body-wrapper.two-col .dashboard-column {
		width: 48%;
		max-width: 500px;
	}
	& .dashboard-column.search-wrapper input::placeholder {
		color: var(--txt-lg);
	}
	& .dashboard-column.search-all-wrapper {
		.dashboard-row {
			min-height: 0;
			padding: 0.5em;
			margin:0;
		}
		a {
			color: var(--blue);
		}
		input::placeholder {
			color: var(--txt-lg);
		}
	}
	& .dashboard-column h3 {
		color: var(--txt-lg);
		font-size: 13px;
		margin-bottom: 23px;
		vertical-align: top;
		span {
			font-size: 13px;
		}
		img {
			height: 18px;
			width: 18px;
			margin: -1px 8px 0 0;
			vertical-align: top;
		}
		img.search {
			background-image: var(--icon-search-lg);
		}
		img.history {
			background-image: var(--icon-history-lg);
		}
		img.activity {
			background-image: var(--icon-activity-lg);
		}
		img.legacy {
			background-image: var(--icon-legacy-lg);
		}
	}
	& .dashboard-column .section-prompt {
		color: var(--txt-lg);
		text-align: center;
		font-size: 12px;
		margin-top: 10px;
		padding: 0 40px;
	}
	& .dashboard-row {
		display: block;
		background: var(--bg-d2);
		border-radius: 3px;
		border: 1px solid transparent;
		transition: background 0.05s, border 0.05s, top 0.5s, -moz-transform ease-in-out 0.05s;
		position: relative;
		min-height: 60px;
		&:hover {
			cursor: pointer;
			border: 1px solid var(--blue);
		}
		.click-zone {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 1;
			a {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				width: 100%;
				color: transparent;
			}
		}
		.favicon-wrapper {
			margin: 10px 0 0 15px;
			display: inline-block;
			vertical-align: top;
			text-align: center;
		}
		.favicon {
			font-size: 12px;
			padding: 3px;
			border-radius: 3px;
			width: 22px;
			height: 22px;
			border: 1px solid var(--bg-d0);
			background: var(--bg-d0);
		}
		.form-type {
			text-transform: uppercase;
			font-size: 10px;
			padding: 5px;
			border-radius: 3px;
			font-weight: 900;
			width: 30px;
			margin-top: 3px;
			&.tt {
				background: var(--darkgreen);
			}
			&.lc {
				background: var(--violet);
			}
			&.pc {
				background: var(--blue);
			}
			&.em {
				background: var(--blue);
			}
			&.nc {
				background: var(--gray);
			}
		}
		.status-wrapper {
			padding: 0;
			margin: 1px 0 0 0;
			height: 12px;
		}
		.status {
			width: 4px;
			height: 4px;
			border-radius: 2px;
			background: white;
			margin: 3px auto 0 auto;
			display: inline-block;
			vertical-align: top;
		}
		.status.active {
			background: var(--green);
		}
		.status.paused {
			background: var(--red);
		}
		.form-count {
			display: inline-block;
			vertical-align: top;
			color: var(--txt-lg);
			font-size: 10px;
			margin-left: 3px;
			margin-top: -2px;
			padding: 0;
		}
		.menu-hover-wrapper {
			height: 20px;
			width: 20px;
			position: absolute;
			top: 10px;
			right: 4px;
			border-radius: 3px;
			z-index: 2;
			text-align: right;
			.menu-icon {
				position: absolute;
				top: 0;
				right: 0;
				height: 20px;
				width: 20px;
				z-index: 10;
				color: white;
				font-size: 20px;
				text-align: center;
			}
			&:hover {
				cursor: pointer;
				background: var(--bg-l1);
				padding: 4px 0;
				width: auto;
				height: auto !important;
				z-index: 100 !important;
				& > .menu-icon {
					display: none;
				}
			}
			.menu-wrapper {
				display: none;
				height: auto;
			}
			.menu-btn {
				font-size: 12px;
				font-weight: 700;
				color: var(--txt-d);
				text-align: left;
				margin: 0 4px;
				border-radius: 2px;
				padding: 2px 60px 0 10px;
			}
			.menu-btn:hover {
				color: white;
			}
			.menu-btn.edit:hover {
				background: var(--blue);
			}
			.menu-btn.clone:hover {
				background: var(--lt-green-bg);
			}
			.menu-btn.delete:hover {
				background: var(--red);
			}
		}
		.menu-hover-wrapper:hover > .menu-wrapper {
			display: block;
		}
		.delete-btn:hover > span {
			opacity: 1;
		}
		.text {
			padding: 10px 22px 10px 5px;
			height: auto !important;
			display: inline-block;
			vertical-align: top;
			width: calc(100% - 60px);
			text-align: left;
			margin-left: 5px;
		}
		.title {
			font-size: 13px;
		}
		.title span {
			/* color: var(--txt-lg); */
			border: 1px solid;
			font-size: 10px;
			padding: 2px 4px;
			position: relative;
			top: -1px;
			border-radius: 3px;
			margin-left: 5px;
		}
		.title.siteid span {
			display: inline-block;
			margin-top: 3px;
			margin-left: 0;
		}
		.siteid.search span {
			background: rgba(244, 128, 36, 0.35);
			padding: 0 3px;
		}
		.title .salesforce-icon {
			display: inline-block;
			vertical-align: top;
			height: 4px;
			width: 4px;
			border-radius: 2px;
			margin-left: 6px;
			margin-top: 8px;
			background: var(--salesforce-blue);
			padding: 0;
			border: none;
		}
		.title.legacy {
			font-size: 13px;
			color: var(--teal);
			padding: 3px 0 1px 0;
		}
		.user {
			color: var(--txt-lg);
			font-size: 11px;
			margin-top: 1px;
			font-weight: 500;
		}
		.user span.green {
			color: var(--green);
		}
		.user span.yellow {
			color: var(--darkyellow);
		}
		.user span.orange {
			color: var(--orange);
		}
		.siteid {
			margin-top: 1px;
			font-size: 11px;
			color: var(--txt-lg);
		}
		.siteid span {
			color: white;
		}
	}
	& .search-field {
		background: var(--bg-d0-dash);
		border: 1px solid transparent;
		padding: 1em;
		outline: none;
		width: 100%;
		font-size: 13px;
		border-radius: 3px;
		text-align: center;
		color: white;
		&:focus {
			border: 1px solid var(--blue);
		}
	}
	& .dashboard-column {
		.legacy-wrapper {
			margin: 25px 0 0 0;
			.title {
				color: var(--teal);
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.body-wrapper.search-wrapper {
			padding-left: 7em !important;
		}
	}

	@media screen and (max-width: 1100px) {
		.companies {
			grid-template-columns: 1fr;
		}
	}

	@media screen and (max-width: 800px) {
		& .body-wrapper {
			padding: 25px 40px 100px 40px;
		}
		& .dashboard-column {
			width: 100%;
			max-width: unset;
			display: block;
			margin: 25px auto 0 auto;
		}
		& .body-wrapper.two-col .dashboard-column {
			width: 100%;
			max-width: unset;
		}
	}

	h1 {
		color: var(--txt-dg);
		font-size: 1.5em;
		padding-bottom: 1em;
	}

	& .body-wrapper {
		position: absolute;
		top: 60px;
		padding: 25px 25px 100px 25px;
		&.show {
			animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-webkit-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-moz-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
			-o-animation: dashboard-body-show-ani 0.25s ease-in-out 1 forwards;
		}
	}
`;
